import React, { useState } from 'react';
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarMenu,
    SidebarLink,
    SidebarRoute,
    SidebarWrapper,
    SubMenu,
    SubMenuItem
} from './SidebarElements';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { animateScroll as scroll } from 'react-scroll';

const Sidebar = ({ isOpen, toggle }) => {
    const [isOfertaOpen, setIsOfertaOpen] = useState(false);
    const toggleOferta = () => {
        setIsOfertaOpen(!isOfertaOpen);
    };

    const toggleHome = () => {
        scroll.scrollTo(20);
        scroll.scrollToTop();
    };

    const { route, signOut } = useAuthenticator((context) => [
        context.route,
        context.signOut,
    ]);
    const navigate = useNavigate();

    function logOut() {
        signOut();
        navigate('/');
    }

    return (
<SidebarContainer isOpen={isOpen} onClick={(e) => {
    // Close sidebar only if clicking on background, not inside menu
    if (e.target === e.currentTarget) toggle();
}}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink to='/' onClick={toggleHome}>Strona główna</SidebarLink>
                    <SidebarLink to='/ceremonie' onClick={toggleHome}>Ceremonie</SidebarLink>
                        {/* Oferta Dropdown */}
                        <SidebarLink as="div" onClick={(e) => {
                            e.stopPropagation(); // Prevent sidebar from closing
                            toggleOferta();
                        }}>
                            Oferta ▼
                        </SidebarLink>
                        <SubMenu isOpen={isOfertaOpen}>
                            <SubMenuItem to='/pakiety' onClick={toggleHome}>Pakiety ceremonii</SubMenuItem>
                            <SubMenuItem to='/wsparcie' onClick={toggleHome}>Wsparcie</SubMenuItem>
                            <SubMenuItem to='/konsultacje' onClick={toggleHome}>Konsultacje projektowe</SubMenuItem>
                            <SubMenuItem to='/edukacja' onClick={toggleHome}>Edukacja</SubMenuItem>
                            <SubMenuItem to='/bizuteria' onClick={toggleHome}>Biżuteria</SubMenuItem>
                        </SubMenu>
                    {/* Oferta Dropdown */}
                    <SidebarRoute href='https://sklep.atenida.pl' target='_blank' onClick={toggle}>Sklep</SidebarRoute>
                    <SidebarLink to='/news' onClick={toggleHome}>Inspiracje</SidebarLink>
                    <SidebarLink to='/faq' onClick={toggleHome}>FAQ</SidebarLink>
                    <SidebarLink to='/omnie' onClick={toggleHome}>O mnie</SidebarLink>
                    <SidebarLink to='/kontakt' onClick={toggleHome}>Kontakt</SidebarLink>
                    {route === 'authenticated' ? (
                        <SidebarLink to='#' onClick={logOut}>Wyloguj</SidebarLink>
                    ) : (
                        <SidebarLink to='/login' onClick={toggleHome}>Zaloguj</SidebarLink>
                    )}
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    );
};

export default Sidebar;